import styled from 'styled-components';

export const TextareaWrapper = styled.div`
  padding: 20px;
  border-bottom: 1px solid ${(p) => p.theme.colors.grey.input};
  height: calc(100% - 76px);
`;
